<template>
<div>
  <div v-if="invoices.length > 0" class="row">
    <b-table small striped stacked="lg" :fields="table_fields" :items="invoices" :sort-by="'dueDate'">
      <template slot="dueDate" slot-scope="data">{{
          data.item.dueDate | moment("DD/MM/YYYY")
        }}</template>
      <template slot="value" slot-scope="data">{{
          data.value | moeda
        }}</template>
      <template slot="url" slot-scope="data">
        <div class="d-flex justify-content-end">
          <a class="btn btn-primary" :href="data.item.url" target="_blank">Ver Boleto</a>
          <button class="btn btn-secondary" @click="cancelInvoice(data.item._id)">
            Cancelar Boleto
          </button>
        </div>
      </template>
      <template slot="status" slot-scope="data">
        <span @click="updateInvoiceStatus(data.item._id)" class="badge invoice-status" :class="{
              'badge-primary': data.item.status == '1',
              'badge-danger': data.item.status == ('5' || '6' || '7'),
              'badge-success': data.item.status == ('2' || '3' || '4'),
            }">{{ parseStatusCode(data.item.status) }}
        </span>
      </template>
    </b-table>
    <h5 class="error" v-if="invoicesTotalValue.toFixed(2) > totalValue.toFixed(2)">
      Valor total dos boletos gerados está
      {{ (invoicesTotalValue - totalValue) | moeda }} acima do valor total do
      pedido!
    </h5>
    <h5 class="error" v-if="invoicesTotalValue.toFixed(2) < totalValue.toFixed(2)">
      Valor total em boletos está
      {{ (totalValue - invoicesTotalValue) | moeda }} abaixo do valor total do
      pedido!
    </h5>
  </div>
  <div>
    <div class="row" v-for="(link, index) in form" :key="index">
      <div class="col-md-2">
        <b-form-group label="Valor">
          <money v-model="form[index].value" class="form-control" @input="calcRemainingValue"></money>
        </b-form-group>
      </div>
      <div class="col-md-5">
        <b-form-group label="Data de Vencimento">
          <b-form-input v-model="form[index].dueDate" type="date" placeholder="R$ 50,00" />
          <button class="btn btn-primary btn-sm" @click="increaseDueDate(index, 3)">
            +3
          </button>
          <button class="btn btn-primary btn-sm" @click="increaseDueDate(index, 7)">
            +7
          </button>
          <button class="btn btn-primary btn-sm" @click="increaseDueDate(index, 21)">
            +21
          </button>
          <button class="btn btn-primary btn-sm" @click="increaseDueDate(index, 30)">
            +30
          </button>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="Remover">
          <button class="btn btn-secondary btn-sm" @click="removeFormInvoice(index)">
            <i class="fa fa-close"></i>
          </button>
        </b-form-group>
      </div>
    </div>
    <div class="row mt-3 justify-content-start">
      <button class="btn btn-primary btn-sm" @click="addInvoice">
        Novo boleto
      </button>
      <button class="btn btn-primary btn-sm" @click="addByProductInvoices">
        Um boleto por produto
      </button>
      <b-form-input class="installments" v-model="options.evenInvoices" type="number" style="max-width: 70px" />
      <button class="btn btn-primary btn-sm" @click="addEvenInvoices">
        Boletos em parcelas iguais
      </button>
      <button :disabled="remainingValue != 0" v-bind:class="{ disabled: remainingValue != 0 }" class="btn btn-success btn-lg pull-right" @click="submitInvoices">
        Gerar boletos
      </button>
    </div>
  </div>
  <h3 v-if="remainingValue > 0">Faltam {{ remainingValue | moeda }}</h3>
  <h3 class="text-danger" v-if="remainingValue < 0">
    A soma está {{ (remainingValue * -1) | moeda }} maior que o valor total!
  </h3>
</div>
</template>

<script>
import axios from "axios"
export default {
  name: "order-invoices",
  props: ["totalValue", "order"],
  data() {
    return {
      table_fields: [{
          key: "value",
          label: "Valor",
          sortable: true,
        },
        {
          key: "dueDate",
          label: "Vencimento",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "url",
          label: "Ações",
          thClass: "actions",
          sortable: true,
        },
      ],
      options: {
        evenInvoices: 2
      },
      error: null,
      form: [],
      invoices: [],
      remainingValue: 0,
      invoicesTotalValue: 0,
    };
  },
  created() {
    this.form.push({
      value: this.totalValue,
      dueDate: new Date().toISOString().slice(0, 10),
    });
    this.getInvoices();
  },
  methods: {
    getInvoices() {
      axios.get("invoices/" + this.order._id).then((resp) => {
        this.invoices = resp.data;
        this.invoicesTotalValue = this.invoices.reduce((total, current) => {
          return total + current.value;
        }, 0);
      });
    },
    addInvoice() {
      this.form.push({
        value: this.remainingValue,
        dueDate: new Date().toISOString().slice(0, 10),
      });
    },
    updateInvoiceStatus(id) {
      axios
        .get("invoices/" + id + "/updated")
        .then(() => {
          this.getInvoices();
        })
        .catch(this.showError);
    },
    submitInvoices() {
      this.isSending = true;
      this.error = false;
      if (!this.order.address) {
        this.notify(
          `Adicione um endereço ao pedido antes de gerar boletos`,
          "error"
        );
      } else {
        axios({
            method: "POST",
            url: "invoices/" + this.order._id,
            data: this.form,
          })
          .then(({
            data
          }) => {
            const successCount = data.success.length;
            const failureCount = data.error.length;
            if (successCount > 0) {
              this.notify(`${successCount} boletos foram gerados com sucesso!`);
              this.form = [{
                value: this.totalValue,
                dueDate: new Date().toISOString().slice(0, 10),
              }, ];
              this.getInvoices();
            }

            if (failureCount > 0) {
              this.notify(
                `Alguns boletos não foram gerados corretamente`,
                "error"
              );
            }

            this.isSending = false;
          })
          .catch(this.showError);
      }
    },
    cancelInvoice(id) {
      axios
        .delete("invoices/" + id)
        .then(() => {
          this.notify(`Boleto cancelado com sucesso!`);
          this.getInvoices();
        })
        .catch(this.showError);
    },
    addEvenInvoices() {
      let invoices = [];
      let value = this.totalValue / this.options.evenInvoices;
      for (let i = 0; i < this.options.evenInvoices; i++) {
        invoices = [
          ...invoices,
          {
            value,
            dueDate: new Date().toISOString().slice(0, 10)
          },
        ];
      }
      this.form = invoices;
    },
    parseStatusCode(statusCode) {
      switch (Number(statusCode)) {
        case 1:
          return "Processado"
        case 2:
          return "Pago"
        case 3:
          return "Pago depois do vencimento"
        case 4:
          return "Pago depois do cancelamento"
        case 5:
          return "Vencido"
        case 6:
          return "Cancelado"
        case 7:
          return "Cancelado pelo banco"
        default:
          return "Status não identificado"
      }
    },
    addByProductInvoices() {
      // Frete não incluso
      // {
      //   value: this.order.shipping_price,
      //   dueDate: new Date().toISOString().slice(0, 10),
      // },
      let invoices = [];

      for (let item of this.order.items) {
        invoices = [{
            value: item.total,
            dueDate: new Date().toISOString().slice(0, 10)
          },
          ...invoices,
        ];
      }
      this.form = invoices;
    },
    increaseDueDate(index, amount) {
      let date = new Date(this.form[index].dueDate);
      date.setDate(date.getDate() + amount);
      this.form[index].dueDate = date.toISOString().slice(0, 10);
    },
    removeFormInvoice(index) {
      this.form = this.form.filter(
        (value, currentIndex) => currentIndex !== index
      );
      this.calcRemainingValue();
    },
    calcRemainingValue() {
      this.remainingValue = (
        this.totalValue -
        this.form.reduce((total, {
          value
        }) => total + value, 0)
      ).toFixed(2);
    },
  },
};
</script>
<style lang="sass">
.invoice-status
    width: 100%
    background-size: 20%
    cursor: pointer
.installments
  min-width: 50px
.actions
  display: flex
  justify-content: flex-end
  padding-right: 150px !important
</style>
